import { TELEGRAM_MINI_APP_URL } from '../config';

export function CTA() {
  return (
    <section className="py-20 sm:py-28 px-4 bg-gradient-to-b from-tea-50 to-white">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-tea-900 leading-tight">
          Начните закупать чай оптом уже сегодня
        </h2>
        <p className="mt-6 text-lg sm:text-xl text-tea-600 max-w-xl mx-auto">
          Получите прайс-лист с актуальными ценами и каталог из более чем 100 сортов чая. 
          Оформление заказа займёт всего несколько минут.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href={TELEGRAM_MINI_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 px-10 py-5 rounded-xl bg-tea-700 text-white font-semibold hover:bg-tea-800 transition-all shadow-lg shadow-tea-700/20 hover:shadow-xl hover:scale-105 text-lg"
          >
            <span className="text-xl">🛒</span>
            Открыть каталог в Telegram
          </a>
          <a
            href="#catalog"
            className="inline-flex items-center justify-center gap-2 px-10 py-5 rounded-xl border-2 border-tea-300 text-tea-700 font-semibold hover:bg-tea-50 transition-colors text-lg"
          >
            Посмотреть каталог
          </a>
        </div>
        <p className="mt-8 text-sm text-tea-500">
          Более 100 довольных клиентов по всей России
        </p>
      </div>
    </section>
  );
}
